export const loadingStates = [
  {
    animation: 'HOUSE',
    topText: 'Setting up your application...',
    bottomText: 'As a loyal customer, we can use information already on file to streamline the process.',
    altText: 'SVG Below: An animation of a house being built by blocks and circles.',
  },
  {
    animation: 'DATA',
    topText: 'Capturing your financial information...',
    bottomText: "We're verifying accounts and financial data, including available details about your credit.",
    altText: 'SVG Below: An animation of a grid with dotted lines, bar graphs, and spinners moving above it.',
  },
  {
    animation: 'AVATAR',
    topText: 'Personalizing your experience...',
    bottomText: 'Just a bit longer while we customize your options, and offer you a path forward.',
    altText:
      'SVG Below: An animation of an avatar icon with a loading bar circling around it, ' +
      'with spinning and floating squares in the background.',
  },
  {
    animation: 'AVATAR',
    topText: 'Personalizing your experience...',
    bottomText: 'Wherever you are on your home buying journey, we want to optimize your experience.',
    altText:
      'SVG Below: An animation of an avatar icon with a loading bar circling around it, ' +
      'with spinning and floating squares in the background.',
  },
];
